@if (product(); as product) {
  @if (!product.availableForSale && !customLabel?.value) {
    <span class="chip-label type-body-sm chip--outline chip--danger product-tile-label" [class.has--slider]="(media.length || 0) > 1">
      {{ 'product-tegel-uitverkocht-label' | fromDictionary }}
    </span>
  }

  @if (customLabel?.value) {
    <span class="chip-label type-body-sm chip--outline chip--secondary product-tile-label" [class.has--slider]="(media.length || 0) > 1">
      {{ customLabel?.value }}
    </span>
  }

  @if ((media().length || 0) > 1) {
    <section class="product-image-slider-container" [class.has--pagination]="showPagination()" [class.is--loading]="!loaded">
      @if (showPagination()) {
        <nav class="product-image-slider-nav-container">
          <swiper-container
            slides-per-view="5"
            slides-per-group="5"
            loop="false"
            grab-cursor="true"
            space-between="25"
            direction="vertical"
            threshold="10"
            navigation="false"
            pagination="true"
            watch-slides-progress="true"
            (transition-start)="transitioning.set(true)"
            (transition-end)="transitioning.set(false)"
            class="product-image-slider-nav d-none d-md-block"
            #thumbs
          >
            <!--<swiper (swiper)="onSwiper($event)" [config]="swiperConfigThumbs" class="product-image-slider-nav d-none d-md-block" #thumbsSwiper>-->
            @for (slide of media(); track slide.id) {
              <swiper-slide class="swiper-slide h-auto" lazy="true">
                <button class="d-block product-image-slider-nav__item">
                  @if (!loaded) {
                    <span class="skeleton-loading-product-image"></span>
                  }
                  <!--<img class="product-image product-image-ratio" [src]="slide.previewImage.url" [alt]="'Navigate to ' + i" />-->

                  <app-shopify-media-item [mediaItem]="slide" [previewImage]="true" [sizes]="{ sm: 1 }"></app-shopify-media-item>
                </button>
              </swiper-slide>
            }
            <!--</swiper>-->
          </swiper-container>
          <!-- <ul class="product-image-slider-nav d-none d-md-block">
      <li class="mb-1 mb-sm-4 product-image-slider-nav__item" *ngFor="let slide of ImagesCaroussel; let i = index">
        <button class="d-block" (click)="goToSlide(i + 1)">
          <span class="skeleton-loading-product-image" *ngIf="!loaded"></span>
          <img class="product-image product-image-ratio" [src]="slide.url" alt="" />
        </button>
      </li>

    </ul>-->

          @if (media() && media.length > 1) {
            <div class="product-image-slider-nav--mobile type-body-sm mx-1 d-md-none">
              <strong>{{ activeSlide() + 1 }}&nbsp;</strong>
              <span>/ {{ media().length }}</span>
            </div>
          }
        </nav>
      }

      <div class="product-image-slider" [ngClass]="showPagination() ? 'col-md-10' : ''">
        <!-- *ngIf="showPagination ? !loadingUpdates && thumbsLoaded : !loadingUpdates" -->
        <swiper-container
          #swiper
          loop="false"
          grab-cursor="true"
          space-between="0"
          threshold="10"
          navigation="false"
          thumbs-swiper=".product-image-slider-nav"
          (swiper-real-index-change)="indexChange($event)"
        >
          <!--<swiper

        #swiper
        [config]="swiperConfig"
        (transitionStart)="transitionStart($event)"
        (transitionEnd)="transitionEnd()"
        (realIndexChange)="realIndexChange($event)"
      >-->
          @for (item of media(); track item.id) {
            <swiper-slide class="swiper-slide" lazy="true">
              <!-- fstr link used to dynamicly switch to an a href container or not based in @input hasLink -->
              @if (hasLink()) {
                <fstr-link
                  [showText]="false"
                  [button]="{
                    text: '',
                    url: '',
                    routerLink: hasLink() ? (collectionHandle() ? [product.handle] : ['/', 'products', product.handle]) : [],
                  }"
                >
                  <!--<span class="skeleton-loading-product-image" *ngIf="!loaded"></span>-->
                  <app-shopify-media-item
                    [mediaItem]="item"
                    [fallbackAlt]="product.title + ' variant foto ' + $index"
                    [playVideo]="$index === activeSlide()"
                    [sizes]="sizes()"
                  ></app-shopify-media-item>
                </fstr-link>
              } @else {
                <app-shopify-media-item
                  [mediaItem]="item"
                  [fallbackAlt]="product.title + ' variant foto ' + $index"
                  [playVideo]="$index === activeSlide()"
                  [sizes]="sizes()"
                ></app-shopify-media-item>
              }
            </swiper-slide>
          }
          <!--</swiper>-->
        </swiper-container>

        <button class="product-image-slider__control is--prev" (click)="slidePrev()">
          <app-icon title="vorige foto" anchor="icon-chevron-left-xs"></app-icon>
        </button>

        <button class="product-image-slider__control is--next" (click)="slideNext()">
          <app-icon title="volgende foto" anchor="icon-chevron-right-xs"></app-icon>
        </button>
      </div>
    </section>
  } @else {
    <fstr-link
      *ngIf="hasLink"
      [showText]="false"
      [button]="{
        text: '',
        url: '',
        routerLink: collectionHandle() ? [product.handle] : ['/', 'products', product.handle],
      }"
    >
      <app-shopify-media-item
        [mediaItem]="media()[0]"
        [fallbackAlt]="product.title"
        [playVideo]="true"
        [sizes]="sizes()"
      ></app-shopify-media-item>
    </fstr-link>
    <app-shopify-media-item
      *ngIf="!hasLink"
      [mediaItem]="media()[0]"
      [fallbackAlt]="product.title"
      [playVideo]="true"
      [sizes]="sizes()"
    ></app-shopify-media-item>
  }
}
